import React from "react";
import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import Wrapper from "./Wrapper";


export default function App() {

  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );
    return (
      <QueryClientProvider client={queryClient}>
        <Wrapper/>
      </QueryClientProvider>
    );


}
